module.exports = function (arr, obj) {
  if (arr.indexOf) return arr.indexOf(obj)
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i
  }
  return -1
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/components/range/range/lib/lib/indexof.js